import { OrderStatusId, TreatmentType } from 'app/core/enums';

/**
 * Determines whether an order can enter the existing Reprint workflow.
 */
export function isOrderReorderAvailable(treatmentTypeId: number, statusId: OrderStatusId): boolean {
  return [TreatmentType.Moment, TreatmentType.Veneers].includes(treatmentTypeId) && statusId === OrderStatusId.finished;
}
